import React, { useEffect, useState } from "react";
import LoggedOutPage from "./LoggedOutPage";
import { FormattedMessage } from "react-intl";
import { useFetch } from "./FetchProvider";
import { useParams } from "react-router-dom";

type Stage = {
    stage: "processing" | "email_is_verified" | "token_not_found" | "other_error";
    values: Record<string, string> | null;
};

const EmailVerification = () => {
    const params = useParams<{ token: string }>();
    const fetch = useFetch();
    const [stage, setStage] = useState<Stage>({ stage: "processing", values: null });

    useEffect(() => {
        async function _fetchData() {
            const resp = await fetch("/public/verify-email", {
                method: "POST",
                body: JSON.stringify({
                    token: params.token,
                }),
                headers: {
                    "Content-Type": "application/json",
                },
            });
            if (resp.ok) {
                setStage({ stage: "email_is_verified", values: { address: (await resp.json()).address } });
            } else if (resp.status === 404) {
                setStage({ stage: "token_not_found", values: null });
            } else {
                setStage({ stage: "other_error", values: null });
            }
        }

        _fetchData();
    }, []);

    return (
        <LoggedOutPage title={<FormattedMessage id="email_verification.title" />}>
            <div style={{ textAlign: "center", fontSize: "1.5em" }}>
                <p>
                    <FormattedMessage id={`email_verification.stage.${stage.stage}`} values={stage.values} />
                </p>
                {["email_is_verified", "token_not_found", "other_error"].includes(stage.stage) ? (
                    <p>
                        <a href="/public/login">
                            <FormattedMessage id="email_verification.go_to_login" values={stage.values} />
                        </a>
                    </p>
                ) : null}
            </div>
        </LoggedOutPage>
    );
};

export default EmailVerification;
